import axios from "axios";
import {
  PRODUCT_RECS_REQUEST,
  PRODUCT_RECS_SUCCESS,
  PRODUCT_RECS_FAIL,
  CART_RECS_REQUEST,
  CART_RECS_SUCCESS,
  CART_RECS_FAIL,
} from "../constants/upsellConstants";

/* "Goes well with this" — item detail view */
export const getProductRecommendations = (productId) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_RECS_REQUEST });

    const { data } = await axios.get(`/api/upsell/product/${productId}/`);

    dispatch({ type: PRODUCT_RECS_SUCCESS, payload: data });
  } catch (error) {
    // Non-Pro / disabled restaurants and any other failure all resolve to
    // "no module" — this is a dismissible secondary suggestion, never
    // something the guest should see an error state for.
    dispatch({ type: PRODUCT_RECS_FAIL });
  }
};

/* "You might also like" — cart review, before checkout */
export const getCartRecommendations = (productIds) => async (dispatch) => {
  try {
    dispatch({ type: CART_RECS_REQUEST });

    const { data } = await axios.post("/api/upsell/cart/", {
      product_ids: productIds,
    });

    dispatch({ type: CART_RECS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CART_RECS_FAIL });
  }
};

/* Fire-and-forget analytics beacon — no loading/error UI depends on this,
   so it doesn't dispatch anything; a failure (network, ad-blocker) should
   never be visible to the guest. */
export const trackUpsellEvent = (payload) => () => {
  axios.post("/api/upsell/track/", payload).catch(() => {});
};
